import { ApolloError } from '@apollo/client';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  LoadedContent,
  TableContainer,
  TableHeaderBulkSelectCheckbox,
} from '@occc-app/design-system';
import { RetailerNetworkLocationGroupFragment } from '@occc/graphql';
import {
  IPaginationProps,
  PaginationHandler,
  PaginationInfo,
} from '@occc-app/hooks/usePaginatedQuery';
import { useBulkSelect } from '@occc-app/hooks/useBulkSelect';

import { RetailerNetworkUserDetailsLocationGroupsTableRow } from './retailer-network-user-details-location-groups-table-row.component';

type RetailerNetworkUserDetailsLocationGroupsTableProps = ReturnType<typeof useBulkSelect> & {
  loading: boolean;
  error?: ApolloError;
  data?: RetailerNetworkLocationGroupFragment[];
  paginationProps: IPaginationProps;
  paginationInfo?: PaginationInfo;
  onPageChange?: PaginationHandler;
};

export const RetailerNetworkUserDetailsLocationGroupsTable = ({
  loading,
  error,
  data,
  paginationProps,
  bulkSelectedItems,
  handleBulkSelectMultiple,
  handleItemSelect,
}: RetailerNetworkUserDetailsLocationGroupsTableProps) => {
  const currentPageLocationGroupUuids = data?.map((item) => item.uuid) || [];

  const renderData = (items: RetailerNetworkLocationGroupFragment[]) => (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding='checkbox'>
              <TableHeaderBulkSelectCheckbox
                bulkSelectedItems={bulkSelectedItems}
                handleBulkSelectMultiple={handleBulkSelectMultiple}
                currentPageItems={currentPageLocationGroupUuids}
              />
            </TableCell>
            <TableCell>Group Name</TableCell>
            <TableCell>Count of Locations</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((locationGroup) => (
            <RetailerNetworkUserDetailsLocationGroupsTableRow
              locationGroup={locationGroup}
              key={locationGroup.uuid}
              isItemSelected={bulkSelectedItems.has(locationGroup.uuid)}
              handleItemSelect={handleItemSelect}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </TableContainer>
  );

  return (
    <LoadedContent<RetailerNetworkLocationGroupFragment>
      error={error}
      loading={loading}
      items={data}
      renderData={renderData}
    />
  );
};
